// @flow
import Booking from "@kiwicom/frontend-app/scripts/containers/mutable/Booking"

import { cuckooEvents } from "common/consts/enums"
import cuckoo from "common/services/cuckoo/cuckoo"
import { BOOKING_STATUSES } from "mmb/consts/booking"

const trackInvalidBookingData = (booking: Booking) => {
  if (!Object.values(BOOKING_STATUSES).includes(booking.status) && booking.status !== null) {
    cuckoo.critical(cuckooEvents.MANAGE_MAPPER_UNSUPPORTED_STATUS, {
      status: booking.status,
      bid: booking.id,
    })
  }

  /*
   * Track if there is baggage abid without
   * corresponding entry in additionalServices
   */
  const wrongBaggagesAbid = booking.baggages.filter(
    bag =>
      bag.additionalBookingId &&
      !booking.additionalServices.find(a => a.id === bag.additionalBookingId),
  )

  if (wrongBaggagesAbid.length) {
    cuckoo.track(cuckooEvents.MMB_ADDITIONAL_BAGS_WRONG_ABID, {
      bid: booking.bid,
    })
  }

  Object.values(booking.additionalBagsPrices).forEach(bagPrice => {
    // $FlowFixMe
    if (bagPrice.base === 0 && bagPrice.totalService === 0) {
      cuckoo.track(cuckooEvents.MMB_ADDITIONAL_BAGS_ZERO_PRICE, {
        bid: booking.id,
      })
    }
  })
}

export default trackInvalidBookingData
